import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock, ArrowBack } from '@mui/icons-material';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Paper className="max-w-md w-full p-8 text-center">
        <Box className="mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-4">
            <Lock className="text-red-600" sx={{ fontSize: 40 }} />
          </div>
          <Typography variant="h4" className="font-bold text-gray-900 mb-2">
            Access Denied
          </Typography>
          <Typography variant="body1" className="text-gray-600">
            You don't have permission to access this page.
          </Typography>
        </Box>

        <Box className="space-y-3">
          <Button
            fullWidth
            variant="contained"
            startIcon={<ArrowBack />}
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </div>
  );
};

export default Unauthorized;